import type { Tagged } from "@-/com.npmjs.type-fest";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import { usePersistentKeyboardVisible } from "#persistent-keyboard-runtime";

export type PersistentKeyboardDismissButtonGate = Tagged<
  Record<never, never>,
  "PersistentKeyboardDismissButtonGate"
>;

/**
 * Whether the dismiss control shows: an OS keyboard is up. `null` is the designed hidden state (no
 * keyboard). Flips only when the keyboard shows or hides.
 */
export function usePersistentKeyboardDismissButtonGate(): PersistentKeyboardDismissButtonGate | null {
  const isKeyboardVisible = usePersistentKeyboardVisible();
  return isKeyboardVisible ? createGate<PersistentKeyboardDismissButtonGate>({}) : null;
}
